import { Theme } from "@gfg/ui/theming/create-theme";
import { GlobalStyles, ThemeProvider, createTheme } from "@gfg/ui/theming";
import ErrorBoundary from "~/common/error-boundary";

const globalStyles = (customTheme: Theme) => ({
  a: {
    textDecoration: "none",
    color: customTheme.colors.primary,
  },
  h3: {
    margin: 0,
  },
  p: {
    margin: 0,
  },
});

export const themeV1 = createTheme({
  typography: {
    fontFamilies: {
      base: "Inter",
      heading: "Inter",
      mono: "Roboto Mono",
    },
    label: {
      fontSize: 14,
    },
    h1: {
      fontSize: 60,
      fontWeight: 600,
    },
    h3: {
      fontSize: 30,
      fontWeight: 600,
    },
    h4: {
      fontSize: 24,
      fontWeight: 600,
    },
    h5: {
      fontSize: 18,
      fontWeight: 600,
    },
    h6: {
      fontSize: 14,
      fontWeight: 600,
    },
    small: {
      fontSize: 14,
    },
  },
  schemes: {
    light: {
      text: "#101828",
      primary: "#216FB3",
      lightprimary: "#F0F9FF",
      lighterprimary: "#F5FBFF",
      secondary: "#0086C9",
      lightsecondary: "#EFF8FF",
      lightersecondary: "#F0F9FF",
      lightertertiary: "#E4E7EC",
      tertiary: "#ADADAD",
      success: "#12B76A",
      lightergray: "#F9FAFB",
      darkgray: "#344054",
    },
  },
  shadow: {
    md: "0px 2px 4px rgba(16, 24, 40, 0.12), 1px -4px 6px -4px rgba(16, 24, 40, 0.1)",
  },
});

export function ErrorBoundaryV1({ children }: React.PropsWithChildren<{}>) {
  return <ErrorBoundary theme={themeV1}>{children}</ErrorBoundary>;
}

export default function ThemeProviderV1(props: React.PropsWithChildren<{}>) {
  return <ThemeProvider theme={themeV1} {...props} />;
}

export function GlobalStylesV1() {
  return <GlobalStyles overrides={globalStyles} />;
}
